// extracted by mini-css-extract-plugin
export default {"fs":"abb5ae7824 _2b00687d33"};